import React from 'react';
import { Wind, Droplet, Recycle, Leaf, Coffee, Zap, Trash2 } from 'lucide-react';
import { SustainabilityOutputs as SustainabilityData } from '../../types/calculator';
import { MetricCard } from '../ui/MetricCard';
import { Card } from '../ui/Card';
import { formatWeight, formatVolume, formatNumber, formatEnergy } from '../../utils/formatters';

interface SustainabilityOutputsProps {
  data: SustainabilityData;
}

export const SustainabilityOutputs: React.FC<SustainabilityOutputsProps> = ({ data }) => {
  return (
    <Card gradient className="h-full lg:py-8">
      <h3 className="text-lg font-serif font-semibold text-offblack mb-4 flex items-center gap-2">
        <Leaf className="w-5 h-5 text-[#C35E38]" />
        Sustainability
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <MetricCard
          icon={Coffee}
          label="Cups Saved"
          value={data.cupsSaved}
          formatter={(v) => formatNumber(Math.round(v), 0)}
          color="orange"
        />

        <MetricCard
          icon={Wind}
          label="CO₂ Saved"
          value={data.co2Avoided}
          formatter={formatWeight}
          color="emerald"
        />

        <MetricCard
          icon={Zap}
          label="Energy Saved"
          value={data.energySaved}
          formatter={formatEnergy}
          color="sky"
        />

        <MetricCard
          icon={Droplet}
          label="Water Saved"
          value={data.waterSaved}
          formatter={formatVolume}
          color="sky"
        />

        <MetricCard
          icon={Trash2}
          label="Waste Diverted"
          value={data.wasteDiverted}
          formatter={formatWeight}
          color="emerald"
        />

        <MetricCard
          icon={Recycle}
          label="Plastic Saved"
          value={data.plasticSaved}
          formatter={formatWeight}
          color="emerald"
        />
      </div>
    </Card>
  );
};
